import { TextSectionService } from './text-section.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { TEXT_SECTION_TYPE, TextSection } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class TextSectionResolverBase implements Resolve<TextSection> {

  constructor(protected service: TextSectionService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<TextSection> {
    const key: string = TEXT_SECTION_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



